<template>
<div>
    <Login v-if="!$root.user.isLoggedIn" />
    <div v-if="$root.user.isLoggedIn">
        <Header />
        
        <div class="mon">
            <div class="mon-search">
                <vm-card>
                    <vm-row>
                        <vm-group c6>
                            <vm-label :text="'Envelope ID'" />
                            <vm-input v-model="envelopeId" />
                        </vm-group>
                        <vm-group c6 style="padding-top: 10px;">
                            <vm-button :text="'Last inn'" :working="loadingEnvelope" @clicked="loadEnvelope" />
                        </vm-group>
                    </vm-row>
                </vm-card>
            </div>

            <div class="mon-info">
                <vm-card>
                    <vm-row>
                        <vm-group c4>
                            <vm-label :text="'Firma'" />
                            <vm-input v-model="company.name" maxbo disabled />
                        </vm-group>
                        <vm-group c4>
                            <vm-label :text="'Kundenr'" />
                            <vm-input v-model="company.number" maxbo disabled />
                        </vm-group>
                        <vm-group c4 style="padding-top: 12px;">
                            <vm-button :text="'Oppdater'" :working="updatingTable" @clicked="updateTable" />
                        </vm-group>
                    </vm-row>
                </vm-card>
            </div>

            <div class="mon-compare">
                <div class="mon-left">
                    <vm-card list :header="'Verified Archive'">
                        <div class="mon-content">
                            <vm-label outside bold topMargin :text="__('shipping_early')" />
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.days7.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.days7.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days7.threshold, tableShipping.days7.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.days7.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days7.discount, tableShipping.days7.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.days3.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.days3.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days3.threshold, tableShipping.days3.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.days3.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days3.discount, tableShipping.days3.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-label outside bold topMargin :text="__('shipping_normal')" />
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.low.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.low.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.low.threshold, tableShipping.low.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.low.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.low.discount, tableShipping.low.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.med.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.med.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.med.threshold, tableShipping.med.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.med.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.med.discount, tableShipping.med.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.high.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.high.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.high.threshold, tableShipping.high.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.high.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.high.discount, tableShipping.high.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-label outside bold topMargin :text="__('shipping_special')" />
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.precision.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.precision.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.precision.threshold, tableShipping.precision.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.precision.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.precision.discount, tableShipping.precision.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.express.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.express.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.express.threshold, tableShipping.express.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.express.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.express.discount, tableShipping.express.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.crane.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.crane.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.crane.threshold, tableShipping.crane.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="envelopeShipping.crane.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.crane.discount, tableShipping.crane.discount)" />
                                </vm-group>
                            </vm-row>
                        </div>
                    </vm-card>
                    <vm-card>
                        <div class="mon-items">
                            <div class="mon-item" v-for="(item, i) in envelopeItems" :key="'e' + i">
                                <div class="mon-i">
                                    <label class="mon-d">ArticleID:</label>
                                    <label class="mon-v">{{ item.ArticleId }}</label>
                                </div>
                                <div class="mon-i">
                                    <label class="mon-d">CustomerID:</label>
                                    <label class="mon-v">{{ item.CustomerId }}</label>
                                </div>
                                <div class="mon-i">
                                    <label class="mon-d">Threshold:</label>
                                    <label class="mon-v">{{ item.Threshold }}</label>
                                </div>
                                <div class="mon-i">
                                    <label class="mon-d">Discount:</label>
                                    <label class="mon-v">{{ item.DiscountPercentage }}</label>
                                </div>
                                <div class="mon-i mon100">
                                    <label class="mon-d">Identifier:</label>
                                    <label class="mon-v">{{ item.Identifier }}</label>
                                </div>
                            </div>
                        </div>
                    </vm-card>
                </div>
                <div class="mon-right">
                    <vm-card list :header="'Shipping Table API'">
                        <div class="mon-content">
                            <vm-label outside bold topMargin :text="__('shipping_early')" />
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.days7.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.days7.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days7.threshold, tableShipping.days7.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.days7.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days7.discount, tableShipping.days7.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.days3.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.days3.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days3.threshold, tableShipping.days3.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.days3.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.days3.discount, tableShipping.days3.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-label outside bold topMargin :text="__('shipping_normal')" />
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.low.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.low.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.low.threshold, tableShipping.low.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.low.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.low.discount, tableShipping.low.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.med.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.med.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.med.threshold, tableShipping.med.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.med.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.med.discount, tableShipping.med.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.high.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.high.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.high.threshold, tableShipping.high.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.high.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.high.discount, tableShipping.high.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-label outside bold topMargin :text="__('shipping_special')" />
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.precision.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.precision.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.precision.threshold, tableShipping.precision.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.precision.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.precision.discount, tableShipping.precision.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.express.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.express.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.express.threshold, tableShipping.express.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.express.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.express.discount, tableShipping.express.discount)" />
                                </vm-group>
                            </vm-row>
                            <vm-row>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.crane.name" maxbo disabled />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.crane.threshold" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.crane.threshold, tableShipping.crane.threshold)" />
                                </vm-group>
                                <vm-group c4>
                                    <vm-input v-model="tableShipping.crane.discount" maxbo disabled
                                        :invalid="isDifferent(envelopeShipping.crane.discount, tableShipping.crane.discount)" />
                                </vm-group>
                            </vm-row>
                        </div>
                    </vm-card>
                    <vm-card>
                        <div class="mon-items">
                            <div class="mon-item" v-for="(item, i) in tableItems" :key="'e' + i">
                                <div class="mon-i">
                                    <label class="mon-d">ArticleID:</label>
                                    <label class="mon-v">{{ item.ArticleId }}</label>
                                </div>
                                <div class="mon-i">
                                    <label class="mon-d">CustomerID:</label>
                                    <label class="mon-v">{{ item.CustomerId }}</label>
                                </div>
                                <div class="mon-i">
                                    <label class="mon-d">Threshold:</label>
                                    <label class="mon-v">{{ item.Threshold }}</label>
                                </div>
                                <div class="mon-i">
                                    <label class="mon-d">Discount:</label>
                                    <label class="mon-v">{{ item.DiscountPercentage }}</label>
                                </div>
                                <div class="mon-i mon100">
                                    <label class="mon-d">Identifier:</label>
                                    <label class="mon-v">{{ item.Identifier }}</label>
                                </div>
                            </div>
                        </div>
                    </vm-card>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import log from '../log';
import shippingapi from '../shippingapi';
import verified from '../verified';

import Login from '../components/login/Login'
import Header from '../components/nav/Header'

export default {
name: 'Home',
components: {
    Header,
    Login
},
data() {
    return {
        envelopeId: 'r1CbG7oCL',
        loadingEnvelope: false,
        updatingTable: false,
        envelopeShipping: {
            days7: { discount: '', threshold: '', name: 'days7' },
            days3: { discount: '', threshold: '', name: 'days3' },
            low: { discount: '', threshold: '', name: 'low' },
            med: { discount: '', threshold: '', name: 'med' },
            high: { discount: '', threshold: '', name: 'high' },
            precision: { discount: '', threshold: '', name: 'precision' },
            express: { discount: '', threshold: '', name: 'express' },
            crane: { discount: '', threshold: '', name: 'crane' }
        },
        tableShipping: {
            days7: { discount: '', threshold: '', name: 'days7' },
            days3: { discount: '', threshold: '', name: 'days3' },
            low: { discount: '', threshold: '', name: 'low' },
            med: { discount: '', threshold: '', name: 'med' },
            high: { discount: '', threshold: '', name: 'high' },
            precision: { discount: '', threshold: '', name: 'precision' },
            express: { discount: '', threshold: '', name: 'express' },
            crane: { discount: '', threshold: '', name: 'crane' }
        },
        envelopeItems: [],
        tableItems: [],
        company: {}
    }
},
methods: {
    async loadEnvelope() {
        this.loadingEnvelope = true;
        //await new Promise(r => setTimeout(r, 2000));

        const userdata = await verified.getEnvelopeData(this.envelopeId);
        //this.company = userdata.company;
        if (userdata.customer) {
            this.company.name = userdata.customer.name;
            this.company.number = userdata.customer.number;
        }else {
            this.company.name = userdata.company.name;
            this.company.number = userdata.company.customer_number;
        }

        console.log('ud', userdata);
        this.getShippingFromShipping(userdata.shipping);
        /* this.envelopeItems = userdata.shdata;
        this.sortItems(this.envelopeItems); */

        //const table = await shippingapi.getShippingAndRows(userdata.company.customer_number);
        const table = await shippingapi.getShippingAndRows(this.company.number);

        this.tableShipping.days7.threshold = this.formatMoney(table.shipping.days7.threshold);
        this.tableShipping.days3.threshold = this.formatMoney(table.shipping.days3.threshold);
        this.tableShipping.low.threshold = this.formatMoney(table.shipping.low.threshold);
        this.tableShipping.med.threshold = this.formatMoney(table.shipping.low.threshold) + ' og ' + this.formatMoney(table.shipping.high.threshold);
        this.tableShipping.high.threshold = this.formatMoney(table.shipping.high.threshold);
        this.tableShipping.precision.threshold = this.formatMoney(table.shipping.precision.threshold);
        this.tableShipping.express.threshold = this.formatMoney(table.shipping.express.threshold);
        this.tableShipping.crane.threshold = this.formatMoney(table.shipping.crane.threshold);

        this.tableShipping.days7.discount = table.shipping.days7.discount + ' %';
        this.tableShipping.days3.discount = table.shipping.days3.discount + ' %';
        this.tableShipping.low.discount = table.shipping.low.discount + ' %';
        this.tableShipping.med.discount = table.shipping.med.discount + ' %';
        this.tableShipping.high.discount = table.shipping.high.discount + ' %';
        this.tableShipping.precision.discount = table.shipping.precision.discount + ' %';
        this.tableShipping.express.discount = table.shipping.express.discount + ' %';
        this.tableShipping.crane.discount = table.shipping.crane.discount + ' %';

        console.log('table', table);
        this.tableItems = table.rows;
        this.sortItems(this.tableItems);

        this.loadingEnvelope = false;
    },
    isDifferent(value1, value2) {
        return false;
    },
    sortItems(items) {
        for (let i in items) {
            items[i].sort = Number(items[i].ArticleId);
        }
        items.sort((a, b) => (a.sort > b.sort) ? 1 : -1);
    },
    getShippingFromShipping(shipping) {
        this.getSingleShippingFromShipping(this.envelopeShipping.days7, shipping.days7);
        this.getSingleShippingFromShipping(this.envelopeShipping.days3, shipping.days3);
        this.getSingleShippingFromShipping(this.envelopeShipping.low, shipping.low);
        this.getSingleShippingFromShipping(this.envelopeShipping.med, shipping.med);
        this.getSingleShippingFromShipping(this.envelopeShipping.high, shipping.high);
        this.getSingleShippingFromShipping(this.envelopeShipping.precision, shipping.precision);
        this.getSingleShippingFromShipping(this.envelopeShipping.express, shipping.express);
        this.getSingleShippingFromShipping(this.envelopeShipping.crane, shipping.crane);
    },
    getSingleShippingFromShipping(to, from) {
        to.discount = from.discount;
        to.threshold = from.threshold;
    },
    formatMoney(amount) {
        let value = parseFloat(amount).toFixed(0)
        var str = "";
        if (value.toString().length > 6) {
            let index1 = value.toString().length - 6;
            let index2 = value.toString().length - 3;
            str = value.toString().substring(0, index1) + " " + value.toString().substring(index1, index2) + " " + value.toString().substring(index2);
        }else if (value.toString().length > 3) {
            let index = value.toString().length - 3;
            str = value.toString().substring(0, index) + " " + value.toString().substring(index);
        }else {
            str = value.toString();
        }
        return str + ' kr';
    },
    async updateTable() {
        this.updatingTable = true;

        const shipping = JSON.parse(JSON.stringify(this.envelopeShipping));
        this.parseShippingValues(shipping.days7);
        this.parseShippingValues(shipping.days3);
        this.parseShippingValues(shipping.low);
        this.parseShippingValues(shipping.med);
        this.parseShippingValues(shipping.high);
        this.parseShippingValues(shipping.precision);
        this.parseShippingValues(shipping.express);
        this.parseShippingValues(shipping.crane);

        console.log('shipping', this.envelopeShipping);

        const rows = await shippingapi.overwriteShipping(this.company.customer_number, shipping);
        console.log('rows', rows);
        this.updatingTable = false;
    },
    parseShippingValues(values) {
        values.threshold = this.parseOrderValue(values.threshold);
        values.discount = this.parseDiscountValue(values.discount);
    },
    parseOrderValue(value) {
        if (value == "Alle ordre") return "0";
        return value.replace(" kr", "").replace(" ", "");
    },
    parseDiscountValue(value) {
        return value.replace(" %", "").replace(",", ".");
    },
},
async created() {
    
}
}
</script>
<style scoped>

.mon {
    width: 100%;
    padding-top: 50px;
}

.mon-search {
    display: flex;
    width: 500px;
    margin: 0 auto;
    margin-bottom: 40px;;
}

.mon-info {
    float: left;
    width: 100%;
    padding: 0px 100px;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.mon-compare {
    float: left;
    width: 100%;
    padding: 0px 100px;
    box-sizing: border-box;
    margin-bottom: 200px;
}

.mon-left {
    float: left;
    width: 50%;
    padding-right: 10px;
    box-sizing: border-box;
}
.mon-right {
    float: left;
    width: 50%;
    padding-left: 10px;
    box-sizing: border-box;
}

.mon-content {
    min-height: 400px;
}

.mon-items {
    float: left;
    width: 100%;
    margin-bottom: 10px;
    padding: 0px 5px;
    padding-top: 10px;
    border-bottom: solid 1px gray;
    box-sizing: border-box;
}

.mon-item {
    float: left;
    width: 100%;
    min-height: 20px;
    padding: 5px 10px;
    border: solid 1px gray;
    border-bottom: none;
    box-sizing: border-box;
}

.mon-i {
    float: left;
    width: 50%;
}
.mon100 {
    width: 100%;
}

.mon-d {
    color: gray;
    margin-right: 10px;
}

.mon-v {
    font-weight: bold;
}

</style>